import React from "react";

export default function EmailTemplate(){
    return <h2>Inside Email Template</h2>
}